export const Stepper = {
  MuiStepIcon: {
    root: {
      // color: ,
    },
  },
};
